
import { envConfig } from "@env/env-config";

export const UserRestServiceConfig: Array<qpmn.common.rest.IServiceConfig> = [
    /** 获取用户信息 */
    {
        service: "userRestService",
        funcName: "getUserInfo",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/api/userInfo",
        }
    },

    /** 保存用户信息 */
    {
        service: "userRestService",
        funcName: "saveUserInfo",
        config: {
            method: "put",
            appPath: envConfig.apps.base,
            path: "/api/userInfo",
        }
    },

    /** 修改密码 */
    {
        service: "userRestService",
        funcName: "changePassword",
        config: {
            method: "put",
            appPath: envConfig.apps.base,
            path: "/api/userInfo/password",
        }
    },

    /** 修改邮箱 */
    {
        service: "userRestService",
        funcName: "modifyEmail",
        config: {
            method: "put",
            appPath: envConfig.apps.base,
            path: "/api/v2/userInfo/email",
        }
    },

    /** 邮箱验证 */
    {
        service: "userRestService",
        funcName: "mailValidation",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/userInfo/email/validation",
            paramDefaults: {
                token: "@token"
            }
        }
    }
]

